import React, { useState } from "react";
import { Chip, Box, Tooltip, Typography } from "@mui/material";
import { Business as BusinessIcon } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";

const ProviderBadge = ({ providerName }) => {
  const [imgError, setImgError] = useState(false);

  if (!providerName) return null;

  // Construct the icon path.
  // Named exactly as the providerName + .svg
  const iconPath = `/provider-icons/${providerName}.svg`;

  // Fallback to a text chip if image fails
  if (imgError) {
    return (
      <Chip
        icon={<BusinessIcon fontSize="small" />}
        label={providerName}
        size="small"
        variant="outlined"
        sx={{
          borderColor: "divider",
          bgcolor: "background.paper",
          fontWeight: 500,
          height: 24, // Compact height
          "& .MuiChip-label": {
            px: 1,
            fontSize: "0.75rem",
          },
        }}
      />
    );
  }

  return (
    <Tooltip title={providerName} arrow>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "12px", // Rounded like a chip
          px: 1,
          height: 24, // Match Chip height
          bgcolor: "background.paper",
          transition: "background-color 0.2s",
          "&:hover": {
            bgcolor: (theme) => alpha(theme.palette.action.hover, 0.1),
          },
        }}
      >
        <Box
          component="img"
          src={iconPath}
          alt={providerName}
          onError={() => setImgError(true)}
          sx={{
            width: 16,
            height: 16,
            objectFit: "contain",
            mr: 0.5,
          }}
        />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            fontSize: "0.75rem",
            lineHeight: 1,
          }}
        >
          {providerName}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default ProviderBadge;
